export default __webpack_public_path__ + "locales/en/ChangeUserTypeDialog.json?hash=1cc52b714b946e5f1d3cf99238e9f5c0";